import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import Cards from '../ui/card'
import UpcomingAppointmentsCard from '../upcomingAppointmentsCard'
import useIsMobile from '../../hooks/useIsMobile'
import { Container, WelcomeHeader, WelcomeTitle, RedirectLink, CardSection } from './styled'
import { Section, SectionTitle, SectionHeader } from '../../styled/sections'
import theme from '../../styled/theme'
import { useNavigation } from '../../hooks/useNavigation'
import { useHomeLabResults } from '../../hooks/useHomeLabResults'
import { useUpcomingAppointments } from '../../hooks/useUpcomingAppointments'
import InfoCard from '../infoCard'
import { LinkText } from '../ui/text'
import { PATIENT } from '../../constants'
import { DIRECT_ACCES_BY_ROLE_GROUP } from '../../constants/accesByRolesGroup'
import { ROUTE_METADATA } from '../../constants/accesByRolesGroup'
import { canAccessMenuItem } from '../../utils/accessControl'
import LabResultsSection from '../LabResultsSection'

const RouterLinkText = LinkText.withComponent(Link)

const HomeDashBoard = ({ auth, patient, dispatch }) => {
	const patientId = patient?.idPaciente
	const patientERID = patient?.pacienteErid
	const handleNavigation = useNavigation()
	const { upcomingAppointments } = useUpcomingAppointments({ patientId, dispatch })
	const { paginatedResults, loading, error } = useHomeLabResults({ patientERID })

	const isMobile = useIsMobile()
	const textHeader = `¡Hola, ${auth?.nombre}!`

	const getDirectAccesSections = () => {
		const userRoles = auth.gruposRoles || []
		const sections = []

		userRoles.forEach(role => {
			const group = Object.keys(DIRECT_ACCES_BY_ROLE_GROUP).find(key => key === role)
			if (group && DIRECT_ACCES_BY_ROLE_GROUP[group]) {
				const accesses = DIRECT_ACCES_BY_ROLE_GROUP[group]
					.filter(item => canAccessMenuItem(item, auth))
					.filter(item => !(isMobile && item.hideOnMobileDirectAccess))
					.map(item => ({
						id: item.id,
						title: isMobile ? item.mobileLabel || item.label : item.label,
						Icon: isMobile ? item.mobileIcon || item.icon : item.icon,
						routes: item.path
					}))
				const routeMeta = ROUTE_METADATA['/inicio'] && ROUTE_METADATA['/inicio'][group]
				sections.push({
					title: routeMeta?.title || '',
					message: routeMeta?.message || '',
					list: accesses
				})
			}
		})
		return sections
	}

	const getFirstMetadata = () => {
		const userRoles = auth.gruposRoles || []
		for (let i = 0; i < userRoles.length; i++) {
			const role = userRoles[i]
			const meta = ROUTE_METADATA['/inicio'] && ROUTE_METADATA['/inicio'][role]
			if (meta) return meta
		}
		return {}
	}

	const metadata = getFirstMetadata()

	return (
		<Container>
			<WelcomeHeader>
				<WelcomeTitle>{textHeader}</WelcomeTitle>
				{metadata?.message && <p>{metadata.message}</p>}
			</WelcomeHeader>
			{getDirectAccesSections().map((section, idx) => (
				<Section key={idx}>
					<CardSection>
						{auth.gruposRoles?.length > 1 && section.title && (
							<SectionTitle>{section.title}</SectionTitle>
						)}
						<Cards
							iconColor={theme.colors.brand.green}
							list={section.list}
							onClick={path => handleNavigation(path)}
						/>
					</CardSection>
				</Section>
			))}
			{auth.gruposRoles?.includes(PATIENT) && (
				<>
					<Section>
						<SectionHeader align="center" directionMonbile="row" direction="row">
							<SectionTitle mbDesktop="0px">Próximos turnos</SectionTitle>
							{upcomingAppointments && upcomingAppointments.length > 0 && (
								<RedirectLink to="/inicio/mis-turnos">
									Ir a turnos <span>›</span>
								</RedirectLink>
							)}
						</SectionHeader>
						{upcomingAppointments?.length === 0 ? (
							<InfoCard
								title="No tenés turnos programados"
								subtitle={
									<RouterLinkText to="/inicio/turnos-presenciales" size="14px" textDecoration="none">
										Agendar turno
									</RouterLinkText>
								}
							/>
						) : (
							<UpcomingAppointmentsCard
								appointments={upcomingAppointments}
								isCarousel={true}
								showButtons={false}
							/>
						)}
					</Section>
					<Section>
						<SectionHeader align="center" directionMonbile="row" direction="row">
							<SectionTitle mbDesktop="0px">Resultados de laboratorio</SectionTitle>
							{paginatedResults?.length > 0 && (
								<RedirectLink to="/inicio/laboratorios">
									Ver todos <span>›</span>
								</RedirectLink>
							)}
						</SectionHeader>
						<LabResultsSection
							hasActiveFilters={false}
							isCarousel={true}
							loading={loading}
							error={error}
							paginatedResults={paginatedResults}
							isHome={true}
						/>
					</Section>
				</>
			)}
		</Container>
	)
}

const mapStateToProps = ({ auth, patient }) => ({
	auth: auth || {},
	patient: patient || {}
})

export default connect(mapStateToProps)(HomeDashBoard)
